module.exports = __webpack_public_path__ + "static/img/exam-4-bg.82e2a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-4-bg.png
// module id = htZb
// module chunks = 1